<template>
    <div style="padding: 15px">
        <div class="googlemaps" ref="map"></div>
    </div>
</template>

<script>
export default {
    Name: 'GoogleMaps',
    data() {
        return {
            map: null
        }
    },
    mounted() {
        this.map = new window.google.maps.Map(this.$refs["map"], {
            center: { lat: 40.65, lng: -73.949 },
            zoom: 11
        })  
    }
}
</script>

<style scoped>
    .googlemaps {
        height: 400px; 
    }
</style>